import Request from '@/core/QuRequest';

import * as $cache from '@/common/cache';

const req = new Request();

export default {
  methods: {
    getParams() {
      if (this.date[0] && this.date[1]) {
        const params = {
          start_date: this.date[0].format(this.$REQUEST_DATE_FORMAT),
          end_date: this.date[1].format(this.$REQUEST_DATE_FORMAT),
          sales_id: this.sale[1],
          department_id: this.sale[0],
        };

        if (this.compareDate) {
          params.comp_start_date = this.compareDate[0].format(
            this.$REQUEST_DATE_FORMAT,
          );
          params.comp_end_date = this.compareDate[1].format(
            this.$REQUEST_DATE_FORMAT,
          );
        }
        return params;
      }
      return {};
    },

    // 趋势分析汇总接口
    async queryDirectChart() {
      try {
        this.chartLoading = true;
        const params = this.getParams();
        if (!params) {
          this.chartLoading = false;
          return;
        }
        params.dimension = this.summaryDate;
        params.fields = this.field.filter((item) => item).join(',');

        const res = await req.send(req.Apis.sales.report.directChart, params);
        this.chartLoading = false;
        if (res.code === 200) {
          this.chartData = res.data;
        }
      } catch (err) {
        this.chartLoading = false;
        this.$message.error(err.message);
      }
    },

    // 趋势分析 top10
    async queryDirectChartTop10() {
      try {
        this.chartLoading = true;
        const params = this.getParams();
        if (!params) {
          this.chartLoading = false;
          return;
        }
        params.dimension = this.summaryDate;
        params.fields = this.field.filter((item) => item).join(',');

        const res = await req.send(
          req.Apis.sales.report.directChartTop,
          params,
        );
        this.chartLoading = false;
        if (res.code === 200) {
          this.chartData = res.data;
        }
      } catch (err) {
        this.chartLoading = false;
        this.$message.error(err.message);
      }
    },

    // 饼图
    async queryDirectPie() {
      try {
        this.chartLoading = true;
        const params = this.getParams();
        if (!params) {
          this.chartLoading = false;
          return;
        }
        params.dimension = this.dimension;
        params.fields = this.field.filter((item) => item).join(',');

        const res = await req.send(req.Apis.sales.report.directPie, params);
        this.chartLoading = false;
        if (res.code === 200) {
          this.chartData = res.data;
        }
      } catch (err) {
        this.chartLoading = false;
        this.$message.error(err.message);
      }
    },

    // 获取列表
    async queryDirectList() {
      try {
        this.tableLoading = true;
        const params = this.getParams();
        if (!params) {
          this.tableLoading = false;
          return;
        }
        params.dimension = this.summaryDate;
        params.page = this.page;
        params.page_size = this.page_size;
        params.fields = this.fields.join(',');
        params.order_by = this.order_by;
        const res = await req.send(req.Apis.sales.report.directList, params);
        this.tableLoading = false;
        if (res.code === 200) {
          this.rawTableData = res.data;
        }
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(err.message);
      }
    },

    async download() {
      const params = this.getParams();
      if (!params) {
        return;
      }
      params.dimension = this.summaryDate;
      params.page = this.page;
      params.page_size = this.page_size;
      params.fields = this.fields.join(',');
      params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';

      const form = document.createElement('form');
      form.id = 'downloadForm';
      form.name = 'tableDownloadHelper';
      document.body.appendChild(form);
      for (let key in params) {
        if (params.hasOwnProperty(key)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = params[key];
          form.appendChild(input);
        }
      }
      form.method = 'POST';
      form.action = req.getUrl(req.Apis.sales.report.directDownloadList);
      form.submit();
      document.body.removeChild(form);
    },
  },
};
